export interface IGetRequestHeader {
  /** Dadata API token **/
  token: string;
}
export const getRequestHeaders = ({ token }: IGetRequestHeader): [string, string][] => [
  ['Accept', 'application/json'],
  ['Authorization', `Token ${token}`],
  ['Content-Type', 'application/json'],
];
